import React, { useEffect, useState } from "react";
import { Drawer, Spin, Switch, Typography, Divider, List, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getAutoReenableKiosk,
  updateAutoReenableKiosk,
} from "../../redux/settingsSlice";
import { getAllKiosks, changeKioskAutoReenable } from "../../redux/kiosksSlice";

const Settings = ({ onCloseDrawer }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { autoReenableKiosk, loading } = useSelector((state) => state.settings);
  const { kiosks } = useSelector((state) => state.kiosks);
  const kioskList = kiosks?.kiosksList || [];
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    dispatch(getAutoReenableKiosk());
    dispatch(getAllKiosks());
  }, [dispatch]);

  const onToggleMaster = (checked) => {
    setSaving(true);
    dispatch(updateAutoReenableKiosk(checked))
      .then((res) => {
        if (res.payload) {
          message.success(t("settings.saved"));
        } else {
          message.error(t("settings.saveFailed"));
        }
      })
      .finally(() => setSaving(false));
  };

  const onToggleKiosk = (kioskId, checked) => {
    setSaving(true);
    dispatch(changeKioskAutoReenable({ id: kioskId, autoReenable: checked }))
      .then((res) => {
        if (res.payload) {
          message.success(t("settings.saved"));
        } else {
          message.error(t("settings.saveFailed"));
        }
      })
      .finally(() => setSaving(false));
  };

  return (
    <Drawer
      title={t("settings.title")}
      placement="right"
      onClose={onCloseDrawer}
      width={500}
      open
    >
      <Spin spinning={loading || saving} delay={300}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography.Text strong>
            {t("settings.autoReenableKiosk")}
          </Typography.Text>
          <Switch checked={autoReenableKiosk} onChange={onToggleMaster} />
        </div>
        <Typography.Paragraph type="secondary" style={{ marginTop: 12 }}>
          {t("settings.autoReenableKioskHelp")}
        </Typography.Paragraph>

        <Divider />

        <Typography.Text strong>{t("settings.enabledForKiosks")}</Typography.Text>
        <Typography.Paragraph type="secondary" style={{ marginTop: 4 }}>
          {t("settings.enabledForKiosksHelp")}
        </Typography.Paragraph>
        <List
          size="small"
          dataSource={kioskList}
          locale={{ emptyText: t("settings.noKiosks") }}
          renderItem={(kiosk) => (
            <List.Item
              actions={[
                <Switch
                  checked={kiosk.autoReenable}
                  disabled={!autoReenableKiosk}
                  onChange={(checked) => onToggleKiosk(kiosk.id, checked)}
                />,
              ]}
            >
              {kiosk.name}
            </List.Item>
          )}
        />
      </Spin>
    </Drawer>
  );
};

export default Settings;
